import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=c977fdfa&scoped=true&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=c977fdfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c977fdfa",
  null
  
)

export default component.exports